import { handleActions } from 'redux-actions';

export default handleActions(
	{
		UPDATE_ROOM_FILTER: (state, action) => ({
			...state,
			[action.payload.key]: {
				...state[action.payload.key],
				...action.payload.value,
				status: 'updated',
			},
		}),

		UPDATE_DISTRICT_OPTIONS: (state, action) => ({
			...state,
			district: {
				...state.district,
				list: action.payload.list,
				select: [],
			},
		}),

		UPDATE_MRT_STATION_OPTIONS: (state, action) => ({
			...state,
			mrtStation: {
				...state.mrtStation,
				list: action.payload.list,
				select: [],
			},
		}),

		FETCH_ROOM_FILTER_FULFILLED: (state, action) => ({
			...state,

			city: {
				...state.city,
				list: action.payload.cityList,
				data: action.payload.cityData,
			},

			district: {
				...state.district,
				data: action.payload.districtsData,
			},

			mrtLine: {
				...state.mrtLine,
				list: action.payload.mrtLineList,
				data: action.payload.mrtLineData,
			},

			mrtStation: {
				...state.mrtStation,
				data: action.payload.mrtStationData,
			},

			apartment: {
				...state.apartment,
				list: action.payload.apartmentList,
				data: action.payload.apartmentData,
			},

			roomType: {
				...state.roomType,
				list: action.payload.roomTypeList,
				data: action.payload.roomTypeData,
			},

			price: {
				...state.price,
				range: action.payload.minMaxPriceRange,
				minMax: action.payload.minMaxPriceRange,
			},

			area: {
				...state.area,
				range: action.payload.minMaxAreaRange,
				minMax: action.payload.minMaxAreaRange,
			},

			feature: {
				...state.feature,
				list: action.payload.featureList,
				data: action.payload.featureData,
			},
		}),

		SET_ROOM_FILTER_QUERY: (state, action) => ({
			...state,

			city: { ...state.city, ...action.payload.city },
			district: { ...state.district, ...action.payload.district },
			mrtLine: { ...state.mrtLine, ...action.payload.mrtLine },
			mrtStation: { ...state.mrtStation, ...action.payload.mrtStation },
			mrtAround: { ...state.mrtAround, ...action.payload.mrtAround },
			apartment: { ...state.apartment, ...action.payload.apartment },
			roomType: { ...state.roomType, ...action.payload.roomType },
			month: { ...state.month, ...action.payload.month },
			price: { ...state.price, ...action.payload.price },
			area: { ...state.area, ...action.payload.area },
			double: { ...state.double, ...action.payload.double },
			pet: { ...state.pet, ...action.payload.pet },
			feature: { ...state.feature, ...action.payload.feature },
			unavailableType: { ...state.unavailableType, ...action.payload.unavailableType },
			sort: { ...state.sort, ...action.payload.sort },
		}),
	},
	{
		city: {
			select: [],
			list: [],
			data: {},
			status: 'init',
			message: '',
		},

		district: {
			select: [],
			list: [],
			data: {},
			status: 'init',
			message: '',
		},

		mrtLine: {
			select: [],
			list: [],
			data: {},
			status: 'init',
			message: '',
		},

		mrtStation: {
			select: [],
			list: [],
			data: {},
			status: 'init',
			message: '',
		},

		mrtAround: {
			value: false,
			status: 'init',
			message: '',
		},

		apartment: {
			select: [],
			list: [],
			data: {},
			status: 'init',
			message: '',
		},

		roomType: {
			select: [],
			list: [],
			data: {},
			status: 'init',
			message: '',
		},

		month: {
			range: [],
			yearRange: [],
			status: 'init',
			message: '',
		},

		price: {
			range: [],
			minMax: [],
			status: 'init',
			message: '',
		},

		area: {
			range: [],
			minMax: [],
			status: 'init',
			message: '',
		},

		double: {
			select: { label: '', value: '' },
			status: 'init',
			message: '',
		},

		pet: {
			select: { label: '', value: '' },
			status: 'init',
			message: '',
		},

		feature: {
			select: [],
			list: [],
			data: {},
			status: 'init',
			message: '',
		},

		unavailableType: {
			value: false,
			status: 'init',
			message: '',
		},

		sort: {
			select: [],
			status: 'init',
			message: '',
		},
	},
);



// WEBPACK FOOTER //
// ./src/reducers/filter.js